import { Box, Tab, Tabs } from "@mui/material"
import { TABLE_HEADER_BACKGROUND_COLOR } from "../../../constants/colors"
import { useTranslation } from "react-i18next"
import { ConfirmEnum } from "../../../enums/confirmEnum"

interface Props {
    value: ConfirmEnum,
    onChange: (newValue: ConfirmEnum) => void
}

const TabPanelComponents = ({ value, onChange }: Props) => {
    const { t } = useTranslation('global');
    return (
        <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
            <Box sx={{ borderBottom: 'none', borderColor: 'divider' }}>
                <Tabs value={value} onChange={(e: any, newValue: ConfirmEnum) => {
                    onChange(newValue)
                }} variant="scrollable"
                    scrollButtons="auto">
                    <Tab label={`${t("registerFormRider_page.Not Created")}`} value={ConfirmEnum.NOT_CONFIRM} sx={{ textTransform: 'none' }} />
                    <Tab label={`${t("registerFormRider_page.Already Created")}`} value={ConfirmEnum.CONFIRM} sx={{ textTransform: 'none' }} />
                </Tabs>
            </Box>
        </Box>
    )
}
export default TabPanelComponents